import { Tooltip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import { StyledCell } from 'components/base/Table/Table.styles';

const StateCell = ({ token }) => {
  const StateIcon =
    token?.state === 'ok' ? (
      <Icon name='Check' color='pastelGreen' size='medium' />
    ) : (
      <Icon name='Close' color='radicalRed' size='medium' />
    );
  const failingReason = token?.failing_reason?.description;

  return (
    <StyledCell>
      <Tooltip
        title={failingReason}
        disableHoverListener={!failingReason}
        placement='top'
      >
        {StateIcon}
      </Tooltip>
    </StyledCell>
  );
};

export default StateCell;
